import { ReactNode, useRef } from "react";
import { PlanogramSidepanelTab } from "src/components/PlanogramExtensions/store/types";
import { Color, Flex, Text } from "src/elements";
import { Tooltip } from "src/components/Tooltip/Tooltip";
import { useHoverClickable } from "src/utils/hoverClickable";

interface Props {
  currentTab: PlanogramSidepanelTab;
  tab: PlanogramSidepanelTab;
  setTab: (tab: PlanogramSidepanelTab) => void;
  isDisabled?: boolean;
  disabledReason?: ReactNode;
  children: ReactNode;
}

export const SidepanelButton = ({
  tab,
  setTab,
  currentTab,
  isDisabled,
  disabledReason,
  children,
}: Props) => {
  const ref = useRef(null);

  const { isHovered, isActive: isClicked } = useHoverClickable(ref);
  const isActive = tab === currentTab || isClicked;

  const onClick = () => {
    setTab(tab);
  };

  return (
    <Flex
      ref={ref}
      width="100%"
      background={
        (isActive && Color.greenSmokeActive) ||
        (!isDisabled && isHovered && Color.greenSmokeHover) ||
        Color.greenSmokeDisabled
      }
      justify="center"
      align="center"
      ratio="1"
      padding="5px 0"
      onClick={(!isDisabled && onClick) || undefined}
      isDisabled={isDisabled}
      aria-disabled={isDisabled}
    >
      <Text
        direction="top-bottom"
        variant="small1"
        color={
          (isDisabled && Color.spaceGray) ||
          (isActive && Color.primaryActive) ||
          Color.textSecondary
        }
      >
        {children}
      </Text>
      {isDisabled && disabledReason && <Tooltip position="left">{disabledReason}</Tooltip>}
    </Flex>
  );
};
